/**
 * Trigger a forced file download for a bundled, public, or CDN asset URL.
 * Fetches cross-origin resources as a Blob so browsers force a direct file download
 * instead of opening PDFs in a browser tab.
 * @param {string} assetUrl
 * @param {string} filename
 */
export async function downloadAsset(assetUrl, filename) {
  try {
    const response = await fetch(assetUrl);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename || 'Brochure.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up blob URL after download initiates
    setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
  } catch (error) {
    console.warn('Blob fetch failed, falling back to link download:', error);
    const link = document.createElement('a');
    link.href = assetUrl;
    link.download = filename || 'Brochure.pdf';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

